module.exports = __webpack_public_path__ + "img/logo1.dbdf7a70.png";